import { setContext, getContext } from 'svelte';
import { writable } from 'svelte/store';
import { getUrl } from '../urlUtils';
// Create a store to keep track of the current URL.
export function initCurrentUrl(url) {
    const currentUrl = writable(url || getUrl());
    setContext('CURRENT_URL', currentUrl);
    return currentUrl;
}
// Get the current URL store.
export function getCurrentUrl() {
    return getContext('CURRENT_URL') || writable(getUrl());
}
